import { Questionnaire } from "@/models/Questionnaire";
import { QUESTION_INPUT_TYPES } from "@/constants";

export const QuestionnaireRequest = (argQuestionnaire) => {
  let questionnaire = argQuestionnaire.copy();

  if (!questionnaire.id) {
    delete questionnaire.id;
  }

  if (questionnaire.category) {
    questionnaire.category = questionnaire.category.id;
  }

  if (questionnaire.company) {
    questionnaire.company = questionnaire.company.id;
  }

  if (!questionnaire.identifier || !questionnaire.identifier.trim()) {
    questionnaire.identifier = null;
  }

  questionnaire.questions.map((q, index) => {
    if (!q.id) {
      delete q.id;
    }

    // Set question order
    q.position = index;

    // Set options order
    q.options.map((o, index) => {
      o.position = index;
    });

    if (
      q.input_type !== QUESTION_INPUT_TYPES.CHECKBOX &&
      q.input_type !== QUESTION_INPUT_TYPES.CHECKLIST &&
      q.input_type !== QUESTION_INPUT_TYPES.RADIO_BUTTON &&
      q.input_type !== QUESTION_INPUT_TYPES.SELECT_LIST
    ) {
      delete q.options;
    }

    if (q.input_type !== QUESTION_INPUT_TYPES.CHECKBOX &&
        q.input_type !== QUESTION_INPUT_TYPES.CHECKLIST &&
        q.input_type !== QUESTION_INPUT_TYPES.SIGN &&
        q.input_type !== QUESTION_INPUT_TYPES.IMAGE) {
      q.style_as_yes_no = false;
    }

    if (q.input_type === QUESTION_INPUT_TYPES.NUMBER || q.input_type === QUESTION_INPUT_TYPES.RANGE) {
      if (q.range_min === "") {
        q.range_min = null;
      }

      if (q.range_max === "") {
        q.range_max = null;
      }
    }

    if (q.focus_area) {
      q.focus_area = q.focus_area.id;
    }

    if (q.options) {
      q.options.forEach((option) => {
        if (!option.id) {
          delete option.id; // So we don't send the field at all to backend
        }

        if (option.identifier === "") {
          option.identifier = null;
        }

        if (option.points === "") {
          option.points = null;
        }

        if (option.image) {
          option.image = option.image.id;
        }
      });
    }

    if (q.image) {
      q.image = q.image.id;
    }

    if (!q.id) {
      delete q.conditions; // Cannot save conditions for a new question/questionnaire as we have no ID's to refer to.
    }

    if (q.conditions) {
      q.conditions.forEach((condition) => {
        if (!condition.id ||
          !(condition.condition_question && condition.condition_question.id) ||
          !(condition.condition_option && condition.condition_option.id)) {
          delete condition.id; // So we don't send the field at all to backend
        }

        if(condition.condition_question && condition.condition_question.id && condition.condition_option && condition.condition_option.id)
        {
          condition.condition_question = condition.condition_question.id;
          condition.condition_option = condition.condition_option.id;
        }
      });
    }

    if (questionnaire.feedback_texts) {
      questionnaire.feedback_texts.forEach((feedbackText) => {
        if (!feedbackText.id) {
          delete feedbackText.id; // So we don't send the field at all to backend
        }

        if (feedbackText.start_points === "") {
          feedbackText.start_points = null;
        }

        if (feedbackText.end_points === "") {
          feedbackText.end_points = null;
        }
      });
    }
  });

  if (questionnaire.tags) {
    for (var i = 0; i < questionnaire.tags.length; i++) {
      questionnaire.tags[i] = questionnaire.tags[i].id;
    }
  }

  for (var i = 0; i < questionnaire.visible_to_departments.length; i++) {
    questionnaire.visible_to_departments[i] = questionnaire.visible_to_departments[i].id;
  }

  for (var i = 0; i < questionnaire.visible_to_user_groups.length; i++) {
    questionnaire.visible_to_user_groups[i] = questionnaire.visible_to_user_groups[i].id;
  }

  return questionnaire;
};

export const QuestionnaireResponse = (questionnaire) => {
  return new Questionnaire(questionnaire);
};

export const QuestionnairesResponse = (questionnaires) => {
  return questionnaires.map((q) => QuestionnaireResponse(q));
};
